export default "__VITE_ASSET__BzqWjrac__"